import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsVerifyInformationsScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.VerifyInformations />
    </View>
  );
};

export default PreProposalsVerifyInformationsScreen;
